// postMessage RPC to the host page's `/d.js` loader: the iframe asks the
// loader to run a named `mapping` function and resolve with its result.
// Protocol (kept identical to the legacy zoid-era loader):
//   iframe  -> parent: { type: 'execute', method, args, id }
//   parent  -> iframe: { type: 'execute_result', id, data }
const pendingPromises = new Map<number, (value: unknown) => void>();

type ExecuteResultMessage = {
  type?: string;
  id?: number;
  data?: unknown;
};

export function initExecuteBridge() {
  window.addEventListener(
    'message',
    (event: MessageEvent<ExecuteResultMessage>) => {
      const message = event.data;
      if (
        message &&
        typeof message === 'object' &&
        message.type === 'execute_result' &&
        typeof message.id === 'number'
      ) {
        const resolve = pendingPromises.get(message.id);
        if (resolve) {
          pendingPromises.delete(message.id);
          resolve(message.data);
        }
      }
    },
  );
}

export function execute(method: string, args: unknown[]): Promise<unknown> {
  return new Promise((resolve) => {
    const id = Math.random();
    pendingPromises.set(id, resolve);
    window.parent.postMessage({ type: 'execute', method, args, id }, '*');
  });
}
